import { useSelector, useDispatch } from "react-redux";
import React, { useState } from "react";
import useBootstrap from "../customHooks/useBootstrap.js";
import BaseImage from "../baseComponents/baseImage.js";
import BaseButton from "../baseComponents/baseButton.js";
import BaseCheckbox from "../baseComponents/baseCheckbox.js";
import BaseParagraph from "../baseComponents/baseParagraph.js";
import BaseHyperlink from "../baseComponents/baseHyperlink.js";
import BaseHeading from "../baseComponents/baseHeading.js";
import { Container, Row, Column, Col, Modal, Button } from "reactstrap";
import {action as userActions, asyncActions as userAsyncActions} from "../store/slices/userSlice.js";

const Giveaway = ({}) => {

    const dispatch = useDispatch();

    const giveaways = useSelector(state => state.userState.giveaways);
    const { trashold, classes, trashold4, trashold8 } = useBootstrap();
    const [showModal, setShowModal] = useState(null);
  
    const [acceptGiveawayRules, setAcceptGiveawayRules] = useState(false);
    const [acceptPersonalData, setAcceptPersonalData] = useState(false);

    const systemState = useSelector((state) => state.systemState);
    const giveawayRulesLink = systemState.settings.giveaway_rules_link;
    const giveawayPersonalDataLink = systemState.settings.giveaway_personal_data_link;

    const [errorMsg, setErrorMsg] = useState("");

    const handleAcceptGiveawayRules = () => {
      setAcceptGiveawayRules(!acceptGiveawayRules);
    };

    const handleAcceptPersonalData = () => {
      setAcceptPersonalData(!acceptPersonalData);
    };

    const handleCloseModal = () => {
      setErrorMsg("");
      setAcceptGiveawayRules(false);
      setAcceptPersonalData(false);
      setShowModal(null);
    };


    const handleJoinGiveaway = (giveaway) => {
      setShowModal(giveaway);
    };

    const handleAcceptPermissions = (giveawayId) => {
      if (acceptGiveawayRules == true && acceptPersonalData == true){
        //setShowModal(null);
        setErrorMsg(null);
        dispatch(
          userAsyncActions.joinGiveaway({ 
            giveawayId: giveawayId, 
            permission1: acceptGiveawayRules,
            permission2: acceptPersonalData,
            setErrorMsg: setErrorMsg,
            handleCloseModal: handleCloseModal
          })
        );
      }
      else {
        setErrorMsg("giveawayPermissionsNotChecked");
      }
    };

    return (
      <>
      {
        giveaways && giveaways.map(giveaway => {
          return (
            <div key={giveaway.id}>
              <div className={`w-75 card ${classes.onOrAboveTrashold.show(true)}`} style={{ borderRadius: '0' }}>
                <div className="card-body">
                  <BaseHeading>{giveaway.giveaway_name}</BaseHeading>
                  <br />
                  <BaseParagraph>{giveaway.giveaway_description}</BaseParagraph>
                  <BaseImage
                    style={{ margin: "10px 0px", maxWidth: "100%"}}
                    src={giveaway.images_code}
                  />
                  <Row>
                    <Col {...trashold4} />
                    <Col {...trashold4} />
                    <Col {...trashold4}>
                      {giveaway.permission1 == 'Y' && giveaway.permission2 == 'Y' ? (
                        <BaseButton disabled hasMarginTop={false}>
                          joinGiveawayDisabled
                        </BaseButton>
                      ) : (
                        <BaseButton error={null} onClick={() => handleJoinGiveaway(giveaway)} hasMarginTop={false}>
                          joinGiveaway
                        </BaseButton>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
              <br/>

              <div className={`w-100 card ${classes.onOrAboveTrashold.show(false)}`} style={{ borderRadius: '0' }}>
                <div className="card-body">
                  <BaseHeading>{giveaway.giveaway_name}</BaseHeading>
                  <br />
                  <BaseParagraph>{giveaway.giveaway_description}</BaseParagraph>
                  <BaseImage
                    style={{ margin: "10px 0px",  maxWidth: "100%" }}
                    src={giveaway.images_code}
                  />
                  <Row>
                    <Col {...trashold4} />
                    <Col {...trashold4} />
                    <Col {...trashold4}>
                      {giveaway.permission1 == 'Y' && giveaway.permission2 == 'Y' ? (
                        <BaseButton disabled hasMarginTop={false}>
                          joinGiveawayDisabled
                        </BaseButton>
                      ) : (
                        <BaseButton error={null} onClick={() => handleJoinGiveaway(giveaway)} hasMarginTop={false}>
                          joinGiveaway
                        </BaseButton>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
              <br/>

              
            </div>
            
          )
        })
      }

      {showModal && 
        <Modal isOpen={showModal !== null} toggle={handleCloseModal} centered>
            <div className="modal-header">
                <h5 className="modal-title">{showModal.name}</h5>
                <button type="button" className="close" onClick={handleCloseModal}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <BaseParagraph>giveawayInfo</BaseParagraph>
                <p></p>

                <BaseCheckbox value={acceptGiveawayRules} onChange={handleAcceptGiveawayRules}>
                  <BaseParagraph>giveawayRules</BaseParagraph>
                  <span> </span>
                  <BaseHyperlink href={giveawayRulesLink}>giveawayRulesLink</BaseHyperlink>
                </BaseCheckbox>

                <BaseCheckbox value={acceptPersonalData} onChange={handleAcceptPersonalData}>
                  <BaseParagraph>giveawayPersonalData</BaseParagraph>
                  <span> </span>
                  <BaseHyperlink href={giveawayPersonalDataLink}>giveawayPersonalDataLink</BaseHyperlink>
                </BaseCheckbox>
            </div>
            <div className="modal-footer">
                <BaseButton error={errorMsg} onClick={() => handleAcceptPermissions(showModal.id)} hasMarginTop={false}>
                  acceptGiveawayRules
                </BaseButton>
            </div>
        </Modal>
      }

      </>
    );
};

export default Giveaway;